<template>
  <div
    :class="[
      $style.avatar,
      url && $style.avatarHasImage
    ]"
    :style="{width: size, height: size, flex: `0 0 ${size}`}"
    :title="name"
  >
    <div
      :class="$style.avatarImage"
      v-if="url"
      :style="{ backgroundImage: `url(${url})`}"
    ></div>
    <div
      v-if="!url && name"
      :class="$style.avatarInitials"
      :style="{fontSize}"
    >
      <slot>
        {{ initials(name) }}
      </slot>
    </div>
    <div
      :class="$style.avatarSelected"
      v-if="selected"
    >
      <b-svg
        :class="$style.avatarSelectedIcon"
        name="tick"
        height="20"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: 'b-avatar',
})

withDefaults(
  defineProps<{
    name?: string
    url?: string
    size?: string
    fontSize?: string
    selected?: boolean
  }>(),
  {
    name: '',
    url: '',
    size: '40px',
    fontSize: '16px',
    selected: false,
  }
)

function initials (name: string) {
  let result = ''

  if (name) {
    const splittedName = name.trim().split(' ')
    result = splittedName.length > 1
        ? splittedName[0][0] + splittedName[splittedName.length - 1][0]
        : splittedName[0][0]
  }

  return result?.toUpperCase()
}
</script>

<style lang="scss" module>
@layer legacy-views {

.avatar {
  border-radius: 100%;
  background: url('@/assets/images/avatar-client.svg') center center no-repeat;
  background-size: cover;
  position: relative;

  &HasImage {
    background: none
  }
  &Image {
    width: 100%;
    height: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 100%;
  }
  &Initials {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(-135deg, rgb(238, 238, 238) 0%, rgb(216, 216, 216) 100%);
    color: var(--color-gray-09);
  }
  &Selected {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: black;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    background-color: rgba(42, 44, 50, .7);

    &Icon {
      color: var(--color-white);
      font-weight: 600 !important;
    }
  }
}

}</style>
